import React from "react";

interface IProps {
    forwardedRef: React.RefObject<HTMLDivElement | null>;
    primaryLinkRef: React.RefObject<HTMLAnchorElement | null>;
    tileUID: string | number;
    children?: React.ReactNode;
}

const clickPrimaryLink = (
    primaryLinkRef: React.RefObject<HTMLAnchorElement | null>,
) => {
    if (primaryLinkRef.current) {
        primaryLinkRef.current.click();
    }
};

export const GridTile = (props: IProps): React.ReactNode => {
    return (
        <article
            ref={props.forwardedRef}
            className={`post al-tlovegrid-tile-${props.tileUID}`}
            role="group"
            aria-label="item"
        >
            <section
                className="post__content"
                onClick={() => clickPrimaryLink(props.primaryLinkRef)}
            >
                {props.children}
            </section>
        </article>
    );
};
